<template>
  <h2 class="flex items-center">
    <i
      class="mr-4 h-3 w-3 rounded-full bg-gradient-to-r from-red-600 to-orange-400"
    />
    <span class="flex items-center text-lg font-bold"><slot /></span>
  </h2>
</template>
